class UserRatingsController {
  constructor(UsersService, $scope) {
    'ngInject';
    this.usersService = UsersService;
    this.$scope = $scope;
  }

  $onInit() {
    const isClient = this.userType === 'client';

    const dataSource = this.usersService.getRatingsDataSource(this.userId, isClient);

    dataSource.bind('requestEnd', (e) => {
      if (e.type === 'update' && e.response) {
        const totalRatingsAvg = e.response.totalRatingsAvg;
        if (totalRatingsAvg != null) {
          this.onRatingUpdated({ totalRatingsAvg });
          this.$scope.$apply();
        }
      }
    });

    this.gridOptions = {
      dataSource,
      sortable: true,
      pageable: true,
      resizable: true,
      editable: 'inline',
      noRecords: {
        template: 'No Ratings.'
      },
      save: (e) => {
        const item = e.model;
        const sum = item.category1 + item.category2 + item.category3 + item.category4;
        const avg = sum / 4.0;
        item.ratingSum = parseFloat(sum.toFixed(2));
        item.ratingAvg = parseFloat(avg.toFixed(2));
      },
      columns: [
        { field: 'id',         title: 'ID',          width: '1.5rem', filterable: false },
        { field: 'ratingById', title: 'Rated By ID',  width: '2rem',   filterable: false },
        { field: 'firstName',  title: 'First Name',   width: '3rem',   filterable: false },
        { field: 'lastName',   title: 'Last Name',    width: '3rem',   filterable: false },
        { field: 'category1',  title: 'Category 1',   width: '2.5rem', filterable: false },
        { field: 'category2',  title: 'Category 2',   width: '2.5rem', filterable: false },
        { field: 'category3',  title: 'Category 3',   width: '2.5rem', filterable: false },
        { field: 'category4',  title: 'Category 4',   width: '2.5rem', filterable: false },
        { field: 'ratingSum',  title: 'Rating Sum',   width: '2.5rem', filterable: false },
        { field: 'ratingAvg',  title: 'Avg Rating',   width: '2.5rem', filterable: false },
        { field: 'ratingDate', title: 'Rating Date',  width: '3rem',   filterable: false, template: `#= kendo.toString(new Date(ratingDate), 'dd/MM/yyyy') #` },
        { command: ['edit'],   title: 'Actions',      width: '3rem' },
      ]
    };
  }
}

export default UserRatingsController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-ratings/user-ratings.controller.js
 **/